module.exports = __webpack_public_path__ + "static/media/categories-mobile.40bd3f6b.jpg";